import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mimanetlogo128.png'


const _withScopeId = n => (_pushScopeId("data-v-6e396551"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row px-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0" }, null, -1))
const _hoisted_5 = { class: "col px-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "mimanet logo",
  src: _imports_0
}, null, -1))
const _hoisted_7 = { class: "col px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UserPanel = _resolveComponent("UserPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: `/` }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_UserPanel)
        ])
      ])
    ])
  ]))
}